var _style, _rect, _defs, _defs2, _defs3, _defs4, _defs5, _defs6, _defs7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEvmIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 73.8 77.5",
    style: {
      enableBackground: "new 0 0 73.8 77.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{enable-background:new    ;}\n\t.st2{clip-path:url(#SVGID_00000041289172036904585900000005455689640242088893_);}\n\t.st3{clip-path:url(#SVGID_00000061443312744407650620000007387153639871614339_);}\n\t.st4{clip-path:url(#SVGID_00000073001949371632242000000003495435731598060687_);fill:#2795E3;}\n\t.st5{clip-path:url(#SVGID_00000001661089302526838890000004426905331656781457_);}\n\t.st6{clip-path:url(#SVGID_00000070104008194106509770000005582914920368945036_);fill:#2795E3;}\n\t.st7{clip-path:url(#SVGID_00000066481915344684598080000004660159777071377313_);}\n\t.st8{clip-path:url(#SVGID_00000070836795602633475610000016654402349587177384_);fill:#2795E3;}\n")), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 60,
    height: 70,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD0AAABHCAYAAAC0209OAAAACXBIWXMAAAsSAAALEgHS3X78AAAF 70lEQVR4nO1cS3YjNwyEPuMcKYvcKYfJnbLIkZJY4yzG8FRXVwFgS/JkMXiPjxStJlH48qP2KZ5I v//150n1//Hrb2/PnLcjydQqOXAr9JmCOMxsAZT78bMCtut7tgCWQRuwJ1NX9EY1tyPiOQJomWtA YhvrDvxb7EG7ekOPEMKOqYHZdiBPoi8JAXG7EgS3I+K4ADYABWDWaAXubPp5TAZZlSjqD1oF/8EQ Ae60eX5vI1DV3swBTGf52nxWApDgV4BfI0rArpxFrfqUqzDIr6LNAsg2jnFi4FM602cFOAFd4puQ snyB8gL1S0T8Qm0sL6J8oZJzXWBuJVhnqSVdjR8rLSL4rk8yFtqUU8M3aF9E3+m9Dvh8SONXAZa1 jNK+xF76XLO5V6C53KC+vY+RbVYOAl+iq+hjk8ZyFX1O+yxADkYONJcc60Z8Mti1QCYYrHxZAVfm jVE+tdSZN5fX2Gs4nz/HPsCNSAUypWkOXioYYVByAUoFPSwY7PAZFDYKNqAeBzP26Slw1nh+T2m4 WpGhti/x3Zw5HuD3U8PsNmNin1ZBTGlagVZ+7PK0A85ajNi7wCW2ET1iK5zDoDEKq+jdgY6oQePK ijWnAF8B8C32gj2UslyuzuIi+DX2AQzHUKQiuUttaPaX+BbYVCpcIpenI7baVosRlZ8jNHB3eJDz pWmj9lUKvBtwhM7TyKxKYV0+duMxcOxDQaMwXIyYzGmJUxYyUE1cMdRReUjQzI38KZ5H5DTdTb4K 1m0J1ZZR8YC8cP8yVea9Mmj13cl+mCN6Nf7TfPpR5A4BOuCH9slTehToDD74OWsFuAJdjfEQugc0 AlCpyR37uED2KVqOOA7abetUXQF3Y0yC3mHhrICuAFWMTbTMz6v5queWqAJdSd75WxW4HGiOxG6+ SX4fkQNdTVBF4inYrHmldtRSlgSx6tMVUyfTH6Id8H3eM0/BHvZrBbqLqh2wDqybR803dY2l7WXn 01N/dQwzk6hlnks9v6zNPDKqbjwQ9EQrFRDFtBor+zi387PuiidJnQGMBJS7rGkwcf1OIxUTCiSW ibbtJqQ6JKyi97SoE48ObDVfB7ja6S1pWk3OTCgN8ETd3rcKklPA1TyjHRiCrszX3SAqyU42/d0c DnB3hLSZ05k4mzf7trtKzTYKDU3MAeXPk/jAZszAlbuVZs6BzJk03h5WGpkc80zB4njufK7SuNV2 Zd7dXRMKQDHamTjOxVRptroWdj8E2NCZkrhLIw6wCmyKcQXUzaueT0Dq4qG834rYa9stQxkw3hPz FWqWS3h/VrSSh9F3uyNotabfEK/IciIEjeDzhoFNK38hcBHAGKRkRPRxGsp5nF/z1ZANZpWmlbZT 4+p6JcdCM+uCVuXTqS0MtufYatsGsAr4OWKzOFc+jRfkrxHxL5VX+LvyfZfnuyDGYKrAZZejiqpl KP64Rd0UugDFjFQLEHwWmWW/ZPBsyksrsmo/nYCzzcDVc3zH3Jk5As3vteZpaBpAv+dpsf9Ufq1M /B8qyvyzsNk7364i+t3UnZElscb5uymcvDxX2uZxOae6ZWxlJa6vpM0uq1io8CLFafzv6LWOY3SL HbXen+y7S+C7q9o7gSd4NnsEzeAVcO7jv7MwloCr++kJcOXjCNDV7OMKvAN4i14A3QovIuZHwDiI C0KZStCn3TKRcy2utlQcYLBqLaDAvkXsg7TUtPqiAKlMXfk5m7+L7F25UfuwtktNJ3DYpaC/cB7G HI2LB6VtXl05q1BCRtfiLe4o1Y0T+oEfwuO6GdvuV0ssoCQVudm8LXh1/m3Nm2kY3JghlaLYbDmy T92AAY8XM2NNIw3e9+Ca18dKs27zUAm4S1tS04dAR4ze7FF9VRSvtoa8YanAloCZqUM0fP2w0r7b vSnQXYn4DNBJzW+tlcaxzX1MFfig9gc9HbSixfcy2ZdVmuTaLjmrW8ungk468L6mIs4e3BcRs5fS PgV00sLrxxUdAnp0sofTvS+bP+QF0x9Fq+B/9L8X+Ek/6X9M/wHKj8ZAtnbGswAAAABJRU5ErkJg gg==",
    transform: "matrix(1 0 0 1 9.0443 5.1645)"
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 5.2,
    className: "st0",
    width: 60,
    height: 70
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 18,
    y: 14.2,
    width: 42,
    height: 52
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000120523571148313455420000001461885237724317375_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000120523571148313455420000001461885237724317375_)"
    }
  }, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000008866092509110060540000001318285565602763158_",
    d: "M47.9,59.4L47.9,59.4c-1.5,0-2.9-0.6-4-1.6 c-1-1-1.6-2.4-1.6-3.9c0-3.1,2.5-5.6,5.6-5.6c1.5,0,2.9,0.6,4,1.6c1,1,1.6,2.4,1.6,3.9C53.5,56.9,51,59.3,47.9,59.4L47.9,59.4z  M58.1,52.6L58.1,52.6l-0.5,0c-0.1,0-0.1,0-0.2,0c-0.2,0.1-0.5,0-0.7-0.1c-0.2-0.1-0.3-0.3-0.4-0.6c-0.2-1.2-0.7-2.3-1.4-3.3 c-0.3-0.4-0.2-0.9,0.2-1.2c0,0,0.1-0.1,0.1-0.1l0.4-0.4c0.4-0.4,0.4-1,0-1.3c-0.2-0.2-0.4-0.3-0.6-0.3h0c-0.2,0-0.5,0.1-0.6,0.3 L54,46c0,0-0.1,0.1-0.1,0.1c-0.3,0.4-0.8,0.5-1.2,0.2c-0.5-0.3-1-0.6-1.5-0.8c-0.1,0-0.1,0-0.2-0.1c-0.2-0.1-0.5-0.2-0.7-0.2 c0,0-0.1,0-0.1,0c-0.3-0.1-0.5-0.1-0.8-0.2c-0.4-0.1-0.7-0.5-0.7-0.9c0,0,0,0,0-0.1l0-0.5c0-0.3-0.1-0.5-0.3-0.7 c-0.2-0.2-0.4-0.3-0.6-0.3c0,0,0,0,0,0h0c-0.4,0-0.7,0.2-0.8,0.6c0,0.1-0.1,0.2-0.1,0.4l0,0.5l0,0.1c0,0.4-0.3,0.9-0.7,0.9 c-1.2,0.2-2.4,0.7-3.4,1.5c-0.3,0.2-0.6,0.2-0.9,0.1c0,0,0,0,0,0c0,0-0.1,0-0.1-0.1c0,0-0.1-0.1-0.1-0.1L41.2,46 c-0.2-0.2-0.4-0.3-0.6-0.3h0c-0.2,0-0.5,0.1-0.6,0.3c-0.4,0.4-0.4,1,0,1.3l0.3,0.4c0.3,0.3,0.3,0.8,0.1,1.1 c-0.7,1.1-1.2,2.3-1.4,3.6c-0.1,0.4-0.4,0.7-0.9,0.7l-0.4,0c-0.5,0-0.9,0.4-0.9,1c0,0.3,0.1,0.5,0.3,0.7 c0.2,0.2,0.4,0.3,0.6,0.3l0.4,0h0c0.4,0,0.8,0.3,0.9,0.7c0.1,0.3,0.1,0.6,0.2,0.8c0,0.1,0.1,0.2,0.1,0.3 c0.1,0.2,0.2,0.4,0.3,0.7c0,0.1,0.1,0.2,0.1,0.3c0.2,0.5,0.5,1,0.9,1.5c0.3,0.3,0.2,0.8-0.1,1.1l-0.3,0.3c-0.4,0.4-0.4,1,0,1.3 c0.2,0.2,0.4,0.3,0.6,0.3h0c0.2,0,0.5-0.1,0.6-0.3l0.4-0.4c0.3-0.3,0.7-0.3,1.1-0.1c1.1,0.7,2.2,1.1,3.5,1.3 c0.4,0.1,0.8,0.4,0.8,0.9c0,0,0,0,0,0l0,0.5c0,0.3,0.1,0.5,0.3,0.7c0.2,0.2,0.4,0.3,0.6,0.3h0c0.5,0,0.9-0.4,0.9-1l0-0.5 c0,0,0-0.1,0-0.1c0-0.4,0.2-0.8,0.7-0.9c1.2-0.3,2.3-0.8,3.3-1.6c0.4-0.3,0.9-0.2,1.2,0.1c0,0,0,0.1,0.1,0.1l0.4,0.4 c0.2,0.2,0.4,0.3,0.6,0.3h0c0.2,0,0.5-0.1,0.6-0.3c0.4-0.4,0.4-1,0-1.3l-0.4-0.4c0,0-0.1-0.1-0.1-0.1c-0.4-0.3-0.5-0.8-0.3-1.2 c0.6-1.1,1.1-2.2,1.3-3.4c0-0.2,0.2-0.4,0.4-0.6c0.2-0.1,0.4-0.2,0.7-0.2c0,0,0.1,0,0.1,0l0.5,0c0.5,0,0.9-0.4,0.9-1 c0-0.3-0.1-0.5-0.3-0.7C58.6,52.7,58.4,52.6,58.1,52.6L58.1,52.6z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000178171056307648618400000015160929116273806470_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000008866092509110060540000001318285565602763158_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000178171056307648618400000015160929116273806470_)"
    }
  }, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000161627282422594827120000012665546176080559526_",
    x: 9,
    y: 5.2,
    width: 59,
    height: 69
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000155847086878994312820000001161751184435377049_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000161627282422594827120000012665546176080559526_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 35.8,
    y: 41.5,
    style: {
      clipPath: "url(#SVGID_00000155847086878994312820000001161751184435377049_)",
      fill: "#2795E3"
    },
    width: 24.2,
    height: 24.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000120523571148313455420000001461885237724317375_)"
    }
  }, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000104677976581338159160000015059934965466285705_",
    d: "M48,50L48,50c-2.2,0-3.9,1.7-3.9,3.8 c0,1,0.4,1.9,1.1,2.6c0.7,0.7,1.7,1.1,2.7,1.1h0c2.1,0,3.9-1.7,3.9-3.8c0-1-0.4-1.9-1.1-2.6C50,50.4,49,50,48,50L48,50z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000075847856411696897220000017804908141747952267_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000104677976581338159160000015059934965466285705_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000075847856411696897220000017804908141747952267_)"
    }
  }, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000142148723966378431110000003788279417789220246_",
    x: 9,
    y: 5.2,
    width: 59,
    height: 69
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000029730492297682623470000011287465102258219422_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000142148723966378431110000003788279417789220246_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 43.1,
    y: 49,
    style: {
      clipPath: "url(#SVGID_00000029730492297682623470000011287465102258219422_)",
      fill: "#2795E3"
    },
    width: 9.7,
    height: 9.6
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000120523571148313455420000001461885237724317375_)"
    }
  }, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000076587435952284933420000005548625102587225012_",
    d: "M31.8,44c-0.2,0.2-0.4,0.3-0.6,0.3 c-0.2,0-0.3,0-0.5-0.1l-5.6-3.7c-0.4-0.3-0.5-0.8-0.2-1.2c0.3-0.4,0.8-0.5,1.2-0.2l5,3.3l12.1-12.2c0.3-0.3,0.9-0.3,1.2,0 c0.3,0.3,0.3,0.9,0,1.2L31.8,44z M37.5,56.8c-0.3,0-0.5-0.1-0.8-0.2c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1-0.1 c-0.2-0.1-0.4-0.3-0.6-0.5c-0.5-0.5-0.8-1.2-0.8-1.9c0-1.4,1-2.5,2.3-2.7c0.2-1.1,0.6-2.1,1.2-3c-0.9-1.1-0.8-2.7,0.1-3.7 c0.5-0.5,1.2-0.8,1.9-0.8h0c0.6,0,1.2,0.2,1.7,0.6c0.9-0.5,1.8-0.9,2.8-1.2c0-0.8,0.4-1.5,0.9-2c0.5-0.4,1.1-0.7,1.7-0.7 c0.7,0,1.3,0.3,1.8,0.7c0,0,0,0,0,0l0,0c0.5,0.5,0.8,1.2,0.8,1.9c0.1,0,0.1,0,0.2,0.1c0.1,0,0.2,0.1,0.3,0.1 c0.3-1.5,0.5-3.2,0.5-5V19.3l-0.7-0.1c-4.4-0.6-8.7-1.8-12.7-3.6l-3.3-1.5l-2.6,1.2c-3.9,1.8-8.1,3.1-12.4,3.7L18,19.3v19.2 c0,10.6,5.6,15.5,16.6,21.4c0.1,0,0.1,0,0.2,0c1.2-0.6,2.2-1.2,3.2-1.8c0,0,0,0,0,0C37.8,57.7,37.6,57.3,37.5,56.8L37.5,56.8z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000120555344600380728780000015269157366068128947_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000076587435952284933420000005548625102587225012_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000120555344600380728780000015269157366068128947_)"
    }
  }, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000113318528258258902530000013524749170207012787_",
    x: 9,
    y: 5.2,
    width: 59,
    height: 69
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000183238165345816703170000004575570665986838456_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000113318528258258902530000013524749170207012787_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 13.2,
    style: {
      clipPath: "url(#SVGID_00000183238165345816703170000004575570665986838456_)",
      fill: "#2795E3"
    },
    width: 35.3,
    height: 47.8
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvmIcon);
export default __webpack_public_path__ + "static/media/evm-icon.18b5f133b553b6993dce9c5fec76d49c.svg";
export { ForwardRef as ReactComponent };